module.exports = __webpack_public_path__ + "img/warm_up_white.08344feb.svg";